var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRatingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rating-star_svg__clip0_7573_5431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.321 2.157c.214-.654 1.145-.654 1.358 0l1.085 3.315a.71.71 0 00.678.49h3.51c.691 0 .978.879.42 1.283l-2.84 2.048a.71.71 0 00-.259.793l1.084 3.315c.214.654-.54 1.198-1.098.793l-2.84-2.048a.717.717 0 00-.839 0l-2.839 2.048c-.559.405-1.312-.14-1.098-.793l1.084-3.315a.705.705 0 00-.26-.793L1.63 7.245c-.56-.404-.271-1.284.42-1.284h3.508a.717.717 0 00.68-.49L7.32 2.158z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rating-star_svg__clip0_7573_5431"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgRatingStar;